import { UserId_Schema } from "@/services/user/userSchema";
import { z } from "zod";

export type UserId = z.infer<typeof UserId_Schema>;
export type UserToken = string;

export type User = {
  id: UserId;
  email: string;
  isEmailVerified: boolean;
  name: string;
  avatar: string | null;
  showPrices: boolean;
  type: AccountType;
  role: Role;
  rights: Right[];
  token: UserToken;
};

export type UserBasicInfo = {
  nickname: string;
  avatar: string | null;
  rating: number;
  ratingCount: number;
  itemsCount?: number;
};

export enum AccountType {
  Common = "common",
  Facebook = "facebook",
  Google = "google",
}

export enum Role {
  Admin = "admin",
  Collector = "collector",
}

// There are more, but the FE doesn't use them. Feel free to add them if needed.
export enum Right {
  Marketplace2_0 = "marketplace",
}
